/**
 * Conversations API client — persistent agent chat threads
 */
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';
const BASE = `${API_BASE_URL}/api/v1/conversations`;

export interface ConversationSummary {
  id: string;
  title: string;
  company?: string | null;
  industry?: string | null;
  created_at: string;
  updated_at: string;
  message_count?: number;
  last_message_at?: string | null;
  metadata?: Record<string, any>;
}

export interface PersistedMessage {
  id: string;
  conversation_id: string;
  role: 'user' | 'model';
  text: string;
  tool_calls: any[];
  citations: any[];
  iterations: number;
  ok: boolean;
  created_at: string;
}

export interface ConversationDetail extends ConversationSummary {
  messages: PersistedMessage[];
}

export interface ConvStats { conversations: number; messages: number; db_path: string; }

export const conversationsApi = {
  list: (limit = 100) =>
    axios.get<{ conversations: ConversationSummary[]; stats: ConvStats }>(
      `${BASE}?limit=${limit}`).then(r => r.data),
  get: (id: string) =>
    axios.get<ConversationDetail>(`${BASE}/${id}`).then(r => r.data),
  create: (title: string, company?: string, industry?: string) =>
    axios.post<ConversationSummary>(BASE, { title, company, industry })
      .then(r => r.data),
  rename: (id: string, title: string) =>
    axios.patch(`${BASE}/${id}`, { title }).then(r => r.data),
  remove: (id: string) =>
    axios.delete(`${BASE}/${id}`).then(r => r.data),
};
